import { h, render } from 'preact';
import App from './components/App.js';

const renderApp = (element, props) => {
  render(<App {...props} />, element);
};

export default renderApp;
